import Rituais from "../components/Rituais";
import LiveShop from "../components/LiveShop";

export default function ServicosPage() {
  return (
    <div data-testid="page-servicos" className="pt-24 sm:pt-32">
      <Rituais />
      <LiveShop />
    </div>
  );
}
